import React, { Component, PropTypes } from 'react'
import Link from 'gatsby-link'

import TextBlock from '../../../components/TextBlock'
import ProjectDetails from '../../../components/ProjectDetails'
import ProjectHeader from '../../../components/ProjectHeader'
import SingleImage from '../../../components/SingleImage'
import AHref from '../../../components/AHref'

import featureImage from './uts-preview_1600.jpg'

import './index.scss'

class UTSWebMedia extends Component {
  render () {
    const { children } = this.props

    return (
      <div>
        <ProjectHeader
          heading="Updating a design subject"
          client="University of Technology Sydney"
        />
        <SingleImage img={featureImage} margin />
        <TextBlock>
          <p>In 2016, the University of Technology Sydney (UTS) asked me to renew the learning materials and resources for their Bachelor of Design&rsquo;s &lsquo;Web Media 1&rsquo; subject.</p>
          <p>The project was part of a grant provided by <AHref url="https://www.uts.edu.au/research-and-teaching/learning-and-teaching/learningfutures/overview">learning.futures</AHref>, a university-wide initiative to blending the best of online and face-to-face learning experiences and activities to prepare graduates for the evolving technological demands of the global workplace.</p>
          <p>Over the course of two weeks, I updated existing course material, sourced and created new resources aligned with best practices in the fields of user experience design, interaction design, information architecture, user interface design and front-end development.</p>
          <p>I wrote a new subject outline and updated the student&rsquo;s learning portal to reflect the subject&rsquo;s new structure and content.</p>
          <p>Implemented as of 2017, the newly refreshed subject offers the most relevant learning materials and resources in professional website design and website development practices, and explores them in relation to the commercial practices of user interface design, interaction design, user experience design and information architecture.</p>
        </TextBlock>
      </div>
    )
  }
}

UTSWebMedia.propTypes = {
  children: PropTypes.node,
}

export default UTSWebMedia



// WEBPACK FOOTER //
// ./src/pages/projects/uts-web-media/index.js